var _a;
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { parseUrl, getCurrentScript } from '@slardar/sdk-web';
export var REPORT_DOMAIN = process.env.SDK_SLARDAR_REPORT_DOMAIN;
export var SETTINGS_DOMAIN = REPORT_DOMAIN;
export var PLUGINS_LOAD_PREFIX = process.env.SDK_SLARDAR_PLUGINS_PROTOCOL + "//" + (process.env.UPLOAD_CDN
    ? parseUrl(((_a = getCurrentScript()) === null || _a === void 0 ? void 0 : _a.getAttribute('src')) || '').domain || process.env.SDK_SLARDAR_PLUGINS_HOST
    : process.env.SDK_SLARDAR_PLUGINS_HOST) + process.env.SDK_SLARDAR_PLUGINS_PATH;
export var SDK_VERSION = process.env.SDK_SLARDAR_VERSION || '';
export var SDK_NAME = 'SDK_SLARDAR_WEB';
export var SETTINGS_PATH = '/monitor_web/settings/browser-settings';
export var BATCH_REPORT_PATH = process.env.SDK_SLARDAR_REPORT_BATCH_PATH;
export var STORAGE_PREFIX = 'SLARDAR';
export var USER_ID_COOKIE_NAME = 'MONITOR_WEB_ID';
export var DEVICE_ID_COOKIE_NAME = 'MONITOR_DEVICE_ID';
export var DEFAULT_IGNORE_PATHS = ['/log/sentry/', BATCH_REPORT_PATH, SETTINGS_PATH];
export var DEFAULT_SAMPLE_GRANULARITY = 'session';
export var EXTRA_INDEPENDENT_PLUGINS = ['blankScreen', 'action'];
export var DEFAULT_SAMPLE_CONFIG = {
    sample_rate: 1,
    include_users: [],
    sample_granularity: DEFAULT_SAMPLE_GRANULARITY,
    rules: {},
};
export var DEFAULT_SENDER_SIZE = 20;
//# sourceMappingURL=constants.js.map